import Q6TaxIssueTypes from './Q6TaxIssueTypes';
export default Q6TaxIssueTypes;